(() => {
  const deliveryCountdowns = document.querySelectorAll('[data-delivery-countdown]');
  const countdownElements = document.querySelectorAll('[data-delivery-countdown-pdp-form], [data-delivery-countdown-sticky-block]');
  const deliveryCountdownConfig = document.querySelector('[data-delivery-countdown-config]');
  const { nddMessageDeliveryDays, nextDayTime, datePickerCaps } = JSON.parse(deliveryCountdownConfig.textContent);

  let targetDate = '';

  const data = {
    nddMessageDeliveryDays: nddMessageDeliveryDays ?? 2,
    datePickerCaps: datePickerCaps ?? [],
    afternoonCutOffHour: nextDayTime ?? '12:59',
    afternoonCutoffCopy: Simba.Liquid.string('"Order within |TIME| for delivery |DAY|"'),
    morningCutoffHour: '37:00', // 13:00 on the next day
    morningCutoffCopy: Simba.Liquid.string('"Want it by |DATE|? Order within |TIME|"'),
    hourSuffix: 'h',
    minuteSuffix: 'm',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    }
  };

  /* ----------------------------
     Helper functions
  ---------------------------- */
  function addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  function formatDate(date) {
    const weekday = date.toLocaleDateString('en-GB', { weekday: 'short' });
    const day = date.getDate();
    const suffix = day > 3 && day < 21 ? 'th' : ['th', 'st', 'nd', 'rd'][day % 10] || 'th';
    const month = date.toLocaleDateString('en-GB', { month: 'short' });

    return `${weekday} ${day}${suffix} ${month}`;
  }

  function isCurrentTimeBeforeAfternoonCutoff(now) {
    const [afternoonCutOffHourString, afternoonCutOffMinuteString] = data.afternoonCutOffHour.split(':');
    const afternoonCutOffHour = parseInt(afternoonCutOffHourString, 10);
    const afternoonCutOffMinute = parseInt(afternoonCutOffMinuteString, 10);
    return now.getHours() < afternoonCutOffHour || (now.getHours() === afternoonCutOffHour && now.getMinutes() < afternoonCutOffMinute);
  }

  function getCountdownTime(now, cutoff) {
    const [cutoffHourString, cutoffMinuteString] = cutoff.split(':');
    const cutoffHour = parseInt(cutoffHourString, 10);
    const cutoffMinute = parseInt(cutoffMinuteString, 10);
    const countdownTime = (cutoffHour - now.getHours()) * 60 * 60 * 1000 - (now.getMinutes() - cutoffMinute) * 60 * 1000 - now.getSeconds() * 1000;
    return countdownTime;
  }

  function updateCountdown(testDay = null, testHours = null, testMinutes = null) {
    let cutoff;
    let dayCopy;
    const now = new Date();
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

    if (testDay !== undefined && testDay !== null) {
      const currentDay = now.getDay();
      now.setDate(now.getDate() + (testDay - currentDay));
      console.log('Setting test day to: ', testDay);
      console.log('Current day is: ', daysOfWeek[testDay]);
    }
    if (testHours !== undefined && testHours !== null) {
      now.setHours(testHours);
      console.log('Setting test hour to: ', testHours);
    }
    if (testMinutes !== undefined && testMinutes !== null) {
      now.setMinutes(testMinutes);
      console.log('Setting test minute to: ', testMinutes);
    }

    const isBeforeAfternoonCutoff = isCurrentTimeBeforeAfternoonCutoff(now);

    if (isBeforeAfternoonCutoff) {
      cutoff = data.afternoonCutOffHour;
      targetDate = addDays(now, 1);
      dayCopy = Simba.Liquid.string('"tomorrow"');
    } else {
      cutoff = data.morningCutoffHour;
      targetDate = addDays(now, data.nddMessageDeliveryDays);
      dayCopy = formatDate(targetDate);
    }

    const countdownTime = getCountdownTime(now, cutoff);
    const hours = Math.floor(countdownTime / (1000 * 60 * 60));
    const minutes = Math.floor((countdownTime % (1000 * 60 * 60)) / (1000 * 60));
    const timeCopyRaw = `<span class="text-md-semibold delivery-countdown-copy__span">${hours.toString().padStart(1, '0')}${data.hourSuffix} ${minutes
      .toString()
      .padStart(1, '0')}${data.minuteSuffix}</span>`;
    const dayCopyRaw = `<span class="text-md-semibold delivery-countdown-copy__span">${dayCopy}</span>`;

    countdownElements.forEach((countdown) => {
      if (isBeforeAfternoonCutoff) {
        countdown.innerHTML = data.afternoonCutoffCopy.replace('|TIME|', timeCopyRaw).replace('|DAY|', dayCopyRaw);
      } else {
        countdown.innerHTML = data.morningCutoffCopy.replace('|TIME|', timeCopyRaw).replace('|DATE|', dayCopyRaw);
      }
    });

    if (targetDateMatchesDatepickerCaps()) {
      hideCountdown();
    } else {
      showCountdown();
    }
  }

  function targetDateMatchesDatepickerCaps() {
    if (datePickerCaps.length === 0) return false;
    // js month are 0 indexed and datepicker caps are 1 indexed, hence the "+ 1"
    // caps are formatted as M/D/YYYY.
    const key = `${targetDate.getMonth() + 1}/${targetDate.getDate()}/${targetDate.getFullYear()}`;
    return datePickerCaps.includes(key);
  }

  function hideCountdown() {
    deliveryCountdowns.forEach((countdown) => {
      countdown.style.display = 'none';
    });
  }

  function showCountdown() {
    deliveryCountdowns.forEach((countdown) => {
      countdown.style.display = 'block';
    });
  }

  setInterval(updateCountdown, 60000);
  updateCountdown();

  window.updateCountdown = updateCountdown;

  const DeliveryCountdown = {
    addDays,
    formatDate,
    isCurrentTimeBeforeAfternoonCutoff,
    getCountdownTime,
    updateCountdown,
    targetDateMatchesDatepickerCaps,
    hideCountdown,
    showCountdown
  };

  window.Simba = window.Simba || {};
  window.Simba.DeliveryCountdown = DeliveryCountdown;

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = DeliveryCountdown;
  }
})();
